import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";
import RadioIcon from "../../Components/radioIcon";
import AnswerContainer from "../../Components/answerContainer";
import ImageOpenAnswer from "../../Components/imageOpenAnswer";
import _ from "lodash";

class PresentationButtons extends Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.getButtons = this.getButtons.bind(this);
  }

  onChange(value) {
    const {row} = this.props;
    this.props.onRowUpdated(row.id, value);

    this.forceUpdate();
  }

  getButtons() {
    const {detail, question, isError, validate} = this.props;

    return _.range(1, question.scaleSize + 1).map((current) => {
      const checked = detail && detail.value === current;

      return <div className={"cafetery-wrap-container flex-1"}><div
          key={'diff-' + current}
          className={classnames({
            'cafetery-wrap d-block d-md-flex flex-md-column align-items-center col w-100 p-2': true,
            'active': checked,
          })}
          onClick={() => this.onChange(current)}
      >
        <RadioIcon checked={checked} classes={"far mx-auto align-self-center"} />
      </div>
      </div>
    })
  }

  render() {
    const {question, row, detail} = this.props;

    return <React.Fragment>
      <div className={"d-flex diff-slider-container"}>
        <AnswerContainer
            classes={"text-center pointer-none font-weight-bold flex-1 diff-instruction"}
            answer={row}
            checked={false}
            component={
              <ImageOpenAnswer
                  answer={row.leftContent ? row.leftContent : ""}
                  detail={null}
                  checkboxType={''}
                  answersImage={question.rowsImage}
                  showInput={false}
                  showContent={true}
                  answerOpenAlwaysShow={false}
                  leftComponent={<span className={"arrow left position-absolute"}>
                    <i className={"fa-solid fa-arrow-left-long-to-line"}/>
                  </span>}
              />
            }
        />
        <div className={classnames({
          "d-flex d-lg-none flex-1 buttons-container": true,
          "pl-4 pr-4": true,
          "mt-0 mb-0": true,
          "justify-content-center": true
        })}>
          {this.getButtons()}
        </div>
        <div className={classnames({
          "d-none d-lg-flex flex-1 buttons-container": true,
          "pl-2 pr-2": true,
          "mt-0 mb-0": true,
          "justify-content-center": true,
          "invisible": question.scaleSize > 5
          })}>
          {question.scaleSize <= 6 && <React.Fragment>{this.getButtons()}</React.Fragment>}
        </div>
        <AnswerContainer
            classes={"text-center pointer-none font-weight-bold flex-1 diff-instruction"}
            answer={row}
            checked={false}
            component={
              <ImageOpenAnswer
                  answer={row.rightContent ? row.rightContent : ""}
                  detail={null}
                  checkboxType={''}
                  answersImage={question.rowsImage}
                  showInput={false}
                  showContent={true}
                  answerOpenAlwaysShow={false}
                  rightComponent={<span className={" arrow right position-absolute"}>
                    <i className={"fa-solid fa-arrow-right-long-to-line"}></i>
                  </span>}
              />
            }
        />
      </div>
      {question.scaleSize > 5 && <div className={classnames({
        "d-none d-lg-flex buttons-container right-left-align": true,
        "pl-0 pr-0": true,
        "mt-3 mb-0": true,
        "justify-content-center": true
      }) + " total-buttons-" + question.scaleSize}>
        {this.getButtons()}
      </div>}
    </React.Fragment>
  }
}

PresentationButtons.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  question: PropTypes.shape({
    scaleSize: PropTypes.number.isRequired,
  }).isRequired,
  detail: PropTypes.shape({
    row: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  }),
  onRowUpdated: PropTypes.func.isRequired,
};

export default PresentationButtons;